import { ConfigCatWebProvider } from "@openfeature/config-cat-web-provider";
import type { Provider } from "@openfeature/react-sdk";
import type { OptionsForPollingMode, PollingMode } from "configcat-js";
import { FEATURE_FLAG_API_KEY } from "../../common/env";
import type { IFeatureFlagProviderFactory } from "../../interfaces/feature-flag-provider-factory.interface";
import { ConfigCatProviderCachedDatasource } from "../ConfigCatProviderCachedDatasource/config-cat-provider-cached-datasource";
import type { GTM } from "../gtmEvent/GTMInterfaces";
import { sendGTMEvent } from "../gtmEvents";
import { CustomConfigCatLogger } from "./custom-config-cat-logger/custom-config-cat-logger";

export const DEFAULT_CONFIG_CAT_GTM_EVENT_NAME = "experience_impression";

export class ConfigCatProviderFactory implements IFeatureFlagProviderFactory {
  private readonly _FEATURE_FLAG_API_KEY = FEATURE_FLAG_API_KEY;

  constructor(private readonly _featureFlagCache = new ConfigCatProviderCachedDatasource()) {}

  create(): Provider {
    const apiKey = this._getApiKey();
    const options = this._getProviderConfig();
    const provider = ConfigCatWebProvider.create(apiKey, options);

    return provider;
  }

  private _getProviderConfig(): OptionsForPollingMode<PollingMode.LazyLoad> {
    const logger = new CustomConfigCatLogger();

    return {
      logger,
      setupHooks: (hooks: any) => {
        hooks.on("clientReady", () => console.debug("ConfigCat Client is ready!"));

        hooks.on("flagEvaluated", (evaluationDetails: any) => {
          const { key, value } = evaluationDetails;

          const cachedKeyValue = this._featureFlagCache.get(key);
          const isKeyValueUnchanged = cachedKeyValue === value;

          if (isKeyValueUnchanged) {
            return;
          }

          this._featureFlagCache.set(key, value);

          const eventData: GTM.Event = {
            event: DEFAULT_CONFIG_CAT_GTM_EVENT_NAME,
            feature_flag_name: key,
            feature_flag_value: value,
          };
          sendGTMEvent(eventData);
        });
      },
    };
  }

  private _getApiKey() {
    return this._FEATURE_FLAG_API_KEY;
  }
}
